<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Produkty</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <router-link to="/products">Produkty</router-link>
        </li>
        <li class="active">
          <strong>Nowy</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Opis produktu [pl]</h5>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.name_pl"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.name_pl" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.name_pl[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Tytuł</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.title_seo_pl"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Tytuł"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.title_seo_pl"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.title_seo_pl[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">
                  [SEO] Słowa kluczowe
                </label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.keywords_seo_pl"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Słowa kluczowe"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.keywords_seo_pl"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.keywords_seo_pl[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Opis</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.description_seo_pl"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Opis"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_seo_pl"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_seo_pl[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Krótka treść</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="productObj.short_description_pl"
                  />
                  <div
                    v-if="errorsAdminData?.data?.short_description_pl"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.short_description_pl[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Treść</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="productObj.description_pl"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_pl"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_pl[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Opis produktu [en]</h5>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.name_en"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.name_en" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.name_en[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Tytuł</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.title_seo_en"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Tytuł"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.title_seo_en"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.title_seo_en[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">
                  [SEO] Słowa kluczowe
                </label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.keywords_seo_en"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Słowa kluczowe"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.keywords_seo_en"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.keywords_seo_en[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Opis</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.description_seo_en"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Opis"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_seo_en"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_seo_en[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Krótka treść</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="productObj.short_description_en"
                  />
                  <div
                    v-if="errorsAdminData?.data?.short_description_en"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.short_description_en[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Treść</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="productObj.description_en"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_en"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_en[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Opis produktu [de]</h5>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.name_de"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.name_de" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.name_de[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Tytuł</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.title_seo_de"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Tytuł"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.title_seo_de"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.title_seo_de[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">
                  [SEO] Słowa kluczowe
                </label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.keywords_seo_de"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Słowa kluczowe"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.keywords_seo_de"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.keywords_seo_de[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Opis</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.description_seo_de"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Opis"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_seo_de"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_seo_de[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Krótka treść</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="productObj.short_description_de"
                  />
                  <div
                    v-if="errorsAdminData?.data?.short_description_de"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.short_description_de[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Treść</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="productObj.description_de"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_de"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_de[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Opis produktu [de_de]</h5>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.name_cpde"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.name_cpde"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.name_cpde[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Tytuł</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.title_seo_cpde"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Tytuł"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.title_seo_cpde"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.title_seo_cpde[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">
                  [SEO] Słowa kluczowe
                </label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.keywords_seo_cpde"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Słowa kluczowe"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.keywords_seo_cpde"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.keywords_seo_cpde[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Opis</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.description_seo_cpde"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Opis"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_seo_cpde"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_seo_cpde[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Krótka treść</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="productObj.short_description_cpde"
                  />
                  <div
                    v-if="errorsAdminData?.data?.short_description_cpde"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.short_description_cpde[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Treść</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="productObj.description_cpde"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_cpde"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_cpde[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Opis produktu [de_en]</h5>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.name_cpen"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.name_cpen"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.name_cpen[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Tytuł</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.title_seo_cpen"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Tytuł"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.title_seo_cpen"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.title_seo_cpen[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">
                  [SEO] Słowa kluczowe
                </label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.keywords_seo_cpen"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Słowa kluczowe"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.keywords_seo_cpen"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.keywords_seo_cpen[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">[SEO] Opis</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.description_seo_cpen"
                    type="text"
                    class="form-control inputClass"
                    placeholder="[SEO] Opis"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_seo_cpen"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_seo_cpen[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Krótka treść</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="productObj.short_description_cpen"
                  />
                  <div
                    v-if="errorsAdminData?.data?.short_description_cpen"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.short_description_cpen[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Treść</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="productObj.description_cpen"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description_cpen"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description_cpen[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="canViewQuantity" class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Nakłady</h5>
          </div>
          <div class="form-horizontal">
            <div class="ibox-content">
              <button
                v-if="canAddQuantity"
                @click="addQuantities"
                class="btn btn-sm btn-primary"
              >
                Dodaj
              </button>
              <EasyDataTable
                :headers="headers"
                :items="productObj.quantities"
                alternating
              >
                <template #item-quantity="item">
                  <div v-if="item.isNew">
                    <input
                      v-model="quantities.quantity"
                      type="number"
                      class="form-control inputClass"
                      placeholder="Nakład"
                      required="required"
                    />
                    <div
                      v-if="!quantities.quantity && showModalErrors"
                      class="has-error"
                    >
                      <span class="help-block">
                        To pole musi być wypełnione!
                      </span>
                    </div>
                  </div>
                  <div v-else>
                    <span v-if="item.quantity !== ''">
                      {{ item.quantity }}
                    </span>
                    <span v-else>---</span>
                  </div>
                </template>
                <template #item-display_quantity="item">
                  <div v-if="item.isNew">
                    <input
                      v-model="quantities.display_quantity"
                      type="number"
                      class="form-control inputClass"
                      placeholder="Nakład widoczny"
                      required="required"
                    />
                    <div
                      v-if="!quantities.display_quantity && showModalErrors"
                      class="has-error"
                    >
                      <span class="help-block">
                        To pole musi być wypełnione!
                      </span>
                    </div>
                  </div>
                  <div v-else>
                    <span v-if="item.display_quantity !== ''">
                      {{ item.display_quantity }}
                    </span>
                    <span v-else>---</span>
                  </div>
                </template>
                <template #item-price="item">
                  <div v-if="item.isNew">
                    <input
                      v-model="quantities.price"
                      type="number"
                      class="form-control inputClass"
                      placeholder="Cena"
                      required="required"
                    />
                    <div
                      v-if="!quantities.price && showModalErrors"
                      class="has-error"
                    >
                      <span class="help-block">
                        To pole musi być wypełnione!
                      </span>
                    </div>
                  </div>
                  <div v-else>
                    <span v-if="item.price !== ''">
                      {{ item.price }}
                    </span>
                    <span v-else>---</span>
                  </div>
                </template>
                <template #item-realization_days="item">
                  <div v-if="item.isNew">
                    <input
                      v-model="quantities.realization_days"
                      type="number"
                      class="form-control inputClass"
                      placeholder="Dni realizacji"
                      required="required"
                    />
                  </div>
                  <div v-else>
                    <span v-if="item.realization_days !== ''">
                      {{ item.realization_days }}
                    </span>
                    <span v-else>---</span>
                  </div>
                </template>
                <template #item-actions="item">
                  <div v-if="!item.isNew">
                    <button
                      v-if="canDeleteQuantity"
                      @click="removeQuantity(item)"
                      class="btn btn-danger btn-xs"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                    <button
                      v-if="canViewOptionPrice"
                      @click="quantityPrices(item)"
                      class="btn btn-success btn-xs"
                    >
                      <i class="fa fa-cog" aria-hidden="true"></i>
                    </button>
                  </div>
                  <div v-else>
                    <button
                      @click="saveQuantity()"
                      class="btn btn-success btn-xs"
                    >
                      <i class="fa fa-check" aria-hidden="true"></i>
                    </button>
                    <button
                      @click="cancelQuantity(item)"
                      class="btn btn-danger btn-xs"
                    >
                      <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                  </div>
                </template>
              </EasyDataTable>
            </div>
          </div>
        </div>
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Materiały</h5>
          </div>
          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Wersja polska</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.materials_pl"
                    mode="single"
                    placeholder="Wersja polska"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="materialSelects.materials_pl.options"
                    :filter-results="false"
                    :loading="materialSelects.materials_pl.loading"
                    @search-change="materialSelects.materials_pl.onSearch"
                    @open="materialSelects.materials_pl.bindScroll"
                    @close="materialSelects.materials_pl.unbindScroll"
                  >
                  </Multiselect>
                  <div
                    v-if="errorsAdminData?.data?.materials_pl"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.materials_pl[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Wersja angielska</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.materials_en"
                    mode="single"
                    placeholder="Wersja angielska"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="materialSelects.materials_en.options"
                    :filter-results="false"
                    :loading="materialSelects.materials_en.loading"
                    @search-change="materialSelects.materials_en.onSearch"
                    @open="materialSelects.materials_en.bindScroll"
                    @close="materialSelects.materials_en.unbindScroll"
                  >
                  </Multiselect>
                  <div
                    v-if="errorsAdminData?.data?.materials_en"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.materials_en[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Wersja niemiecka</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.materials_de"
                    mode="single"
                    placeholder="Wersja niemiecka"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="materialSelects.materials_de.options"
                    :filter-results="false"
                    :loading="materialSelects.materials_de.loading"
                    @search-change="materialSelects.materials_de.onSearch"
                    @open="materialSelects.materials_de.bindScroll"
                    @close="materialSelects.materials_de.unbindScroll"
                  >
                  </Multiselect>
                  <div
                    v-if="errorsAdminData?.data?.materials_de"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.materials_de[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">
                  Wersja niemiecka (de)
                </label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.materials_cpde"
                    mode="single"
                    placeholder="Wersja niemiecka (de)"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="materialSelects.materials_cpde.options"
                    :filter-results="false"
                    :loading="materialSelects.materials_cpde.loading"
                    @search-change="materialSelects.materials_cpde.onSearch"
                    @open="materialSelects.materials_cpde.bindScroll"
                    @close="materialSelects.materials_cpde.unbindScroll"
                  >
                  </Multiselect>
                  <div
                    v-if="errorsAdminData?.data?.materials_cpde"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.materials_cpde[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">
                  Wersja angielska (de)
                </label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.materials_cpen"
                    mode="single"
                    placeholder="Wersja angielska (de)"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="materialSelects.materials_cpen.options"
                    :filter-results="false"
                    :loading="materialSelects.materials_cpen.loading"
                    @search-change="materialSelects.materials_cpen.onSearch"
                    @open="materialSelects.materials_cpen.bindScroll"
                    @close="materialSelects.materials_cpen.unbindScroll"
                  >
                  </Multiselect>
                  <div
                    v-if="errorsAdminData?.data?.materials_cpen"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.materials_cpen[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="canViewOptionGroup" class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Grupy opcji</h5>
          </div>
          <div class="form-horizontal">
            <div class="ibox-content">
              <button
                v-if="canAddOptionGroup"
                @click="addGroupOptions"
                class="btn btn-sm btn-primary"
              >
                Dodaj
              </button>
              <div class="table-responsive m-t-sm">
                <table class="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th class="drag-column"></th>
                      <th>ID</th>
                      <th>Nazwa</th>
                      <th>Akcje</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template
                      v-for="(group, groupIndex) in productObj.group_options"
                      :key="group.group_option"
                    >
                      <tr
                        draggable="true"
                        @dragstart="onGroupDragStart(groupIndex)"
                        @dragover.prevent
                        @drop.prevent="onGroupDrop(groupIndex)"
                      >
                        <td
                          class="drag-column"
                          title="Przeciągnij, aby zmienić kolejność"
                        >
                          <i class="fa fa-bars"></i>
                        </td>
                        <td>{{ group.group_option }}</td>
                        <td>{{ group.group_option_name }}</td>
                        <td>
                          <button
                            @click="toggleGroup(group)"
                            class="btn btn-default btn-xs"
                            title="Opcje"
                          >
                            <span v-if="isGroupExpanded(group)">
                              <i class="fa fa-chevron-up"></i>
                            </span>
                            <span v-else>
                              <i class="fa fa-chevron-down"></i>
                            </span>
                          </button>
                          <button
                            v-if="canDeleteOptionGroup"
                            @click="removeGroup(group)"
                            class="btn btn-danger btn-xs"
                            title="Usuń"
                          >
                            <i class="fa fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                      <tr v-if="isGroupExpanded(group)">
                        <td></td>
                        <td colspan="3">
                          <h5>Opcje</h5>
                          <button
                            v-if="canAddOption"
                            @click="openOptionsModal(group)"
                            class="btn btn-sm btn-primary"
                          >
                            Dodaj
                          </button>
                          <table class="table table-bordered m-t-sm">
                            <thead>
                              <tr>
                                <th class="drag-column"></th>
                                <th>ID</th>
                                <th>Nazwa</th>
                                <th>Akcje</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(option, optionIndex) in group.options"
                                :key="option.option"
                                draggable="true"
                                @dragstart.stop="
                                  onOptionDragStart(group, optionIndex)
                                "
                                @dragover.prevent
                                @drop.prevent.stop="
                                  onOptionDrop(group, optionIndex)
                                "
                              >
                                <td
                                  class="drag-column"
                                  title="Przeciągnij, aby zmienić kolejność"
                                >
                                  <i class="fa fa-bars"></i>
                                </td>
                                <td>{{ option.option }}</td>
                                <td>{{ option.option_name }}</td>
                                <td>
                                  <button
                                    v-if="canDeleteOption"
                                    @click="removeOption(group, option)"
                                    class="btn btn-danger btn-xs"
                                    title="Usuń"
                                  >
                                    <i class="fa fa-trash"></i>
                                  </button>
                                  <button
                                    v-if="canViewOptionPrice"
                                    @click="groupPrices(option)"
                                    class="btn btn-success btn-xs"
                                    title="Ceny w zależności od nakładu"
                                  >
                                    <i class="fa fa-cog"></i>
                                  </button>
                                </td>
                              </tr>
                              <tr v-if="!group.options?.length">
                                <td colspan="4" class="text-center">
                                  Brak opcji.
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </template>
                    <tr v-if="!productObj.group_options?.length">
                      <td colspan="4" class="text-center">Brak grup opcji.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Sprawdzanie pliku i podgląd</h5>
          </div>
          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">Typ produktu</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.kind"
                    mode="single"
                    placeholder="Typ produktu"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="options"
                  >
                  </Multiselect>
                  <div v-if="errorsAdminData?.data?.kind" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.kind[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Format</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.format"
                    mode="single"
                    placeholder="Format"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="formats"
                  >
                  </Multiselect>
                  <div v-if="errorsAdminData?.data?.format" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.format[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Spad</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.bleed"
                    type="number"
                    class="form-control inputClass"
                    placeholder="Spad"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.bleed" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.bleed[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Margines tekstu</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.text_margin"
                    type="number"
                    class="form-control inputClass"
                    placeholder="Margines tekstu"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.text_margin"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.text_margin[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Grupa opcji określająca liczbę stron
                </label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.option_group_for_page_count"
                    mode="single"
                    placeholder="Grupa opcji określająca liczbę stron"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="groupOptionsForPageNum"
                  >
                  </Multiselect>
                  <div
                    v-if="errorsAdminData?.data?.option_group_for_page_count"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.option_group_for_page_count[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Grupa opcji określająca liczbę stron okładki
                </label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.option_group_for_cover_page_count"
                    mode="single"
                    placeholder="Grupa opcji określająca liczbę stron okładki"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="groupOptionsForPageNum"
                  >
                  </Multiselect>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="productObj.from_warehouse"
                        type="checkbox"
                      />
                      <span>Produkt z magazynu</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Konfiguracja produktu</h5>
          </div>
          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">Grupa pakowania</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.package"
                    mode="single"
                    placeholder="Grupa pakowania"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="packages"
                  >
                  </Multiselect>
                  <div v-if="errorsAdminData?.data?.package" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.package[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Kategorie</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.categories"
                    mode="tags"
                    placeholder="Kategorie"
                    track-by="name"
                    label="name"
                    :close-on-select="false"
                    :searchable="true"
                    :options="categories"
                  >
                  </Multiselect>
                  <div
                    v-if="errorsAdminData?.data?.categories"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.categories[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Jak przygotować</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.page"
                    mode="single"
                    placeholder="Jak przygotować"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="pages"
                  >
                  </Multiselect>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Zastosowania</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.appliances"
                    mode="tags"
                    placeholder="Zastosowania"
                    track-by="name"
                    label="name"
                    :close-on-select="false"
                    :searchable="true"
                    :options="appliances"
                  >
                  </Multiselect>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Dostępność w sklepach
                </label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.available_in_countries"
                    mode="tags"
                    placeholder="Dostępność w sklepach"
                    track-by="name"
                    label="name"
                    :close-on-select="false"
                    :searchable="true"
                    :options="countries"
                  >
                  </Multiselect>
                  <div
                    v-if="errorsAdminData?.data?.available_in_countries"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.available_in_countries[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div v-if="parameters?.length" class="form-group">
                <label class="col-sm-2 control-label">Parametry</label>
                <div class="col-sm-5">
                  <div class="listbox1">
                    <h4>Nie wybrane</h4>
                    <ejs-listbox
                      :dataSource="filteredParams"
                      :fields="fields"
                      scope="#listbox"
                      :toolbarSettings="toolbarSettings"
                      :allowFiltering="true"
                      filterBarPlaceholder="Filtruj!"
                      @filtering="onFiltering"
                    ></ejs-listbox>
                  </div>
                </div>
                <div class="col-sm-5">
                  <div class="listbox2">
                    <h4>Wybrane</h4>
                    <ejs-listbox
                      :dataSource="selFilteredParameters"
                      id="listbox"
                      :fields="fields"
                      scope="combined-list"
                      @change="onItemChange"
                      :allowFiltering="true"
                      filterBarPlaceholder="Filtruj!"
                      @filtering="onFilteringSel"
                    >
                    </ejs-listbox>
                    <ejs-tooltip
                      ref="tooltipRef"
                      target=".listbox2 li.e-list-item"
                      position="LeftCenter"
                      opensOn="Custom"
                      :width="'300px'"
                      @afterOpen="onTooltipAfterOpen"
                    ></ejs-tooltip>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Opcje przypisane do produktu
                </label>
                <div class="col-sm-5">
                  <div class="listbox1" v-if="pOptions.length">
                    <h4>Nie wybrane</h4>
                    <ejs-listbox
                      :dataSource="pOptions"
                      :fields="fields"
                      scope="#listbox1"
                      @actionComplete="syncSelectedOptions"
                      :toolbarSettings="toolbarSettings"
                    ></ejs-listbox>
                  </div>
                </div>
                <div class="col-sm-5">
                  <div class="listbox2">
                    <h4>Wybrane</h4>
                    <ejs-listbox
                      id="listbox1"
                      @actionComplete="syncSelectedOptions"
                      :dataSource="selectedOptions"
                      :fields="fields"
                    >
                    </ejs-listbox>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Termin realizacji</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.deadline"
                    type="number"
                    class="form-control inputClass"
                    placeholder="Termin realizacji"
                  />
                  <div v-if="errorsAdminData?.data?.deadline" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.deadline[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Deadline</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.deadline_time"
                    type="time"
                    step="1"
                    class="form-control inputClass"
                    placeholder="Deadline"
                  />
                  <div
                    v-if="errorsAdminData?.data?.deadline_time"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.deadline_time[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Grupa opcji określająca termin realizacji
                </label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="productObj.option_group_for_deadline"
                    mode="single"
                    placeholder="Grupa opcji określająca termin realizacji"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="groupOptionsForPageNum"
                  >
                  </Multiselect>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Waga jednostkowa</label>
                <div class="col-sm-10">
                  <input
                    v-model="productObj.unit_weight"
                    type="number"
                    class="form-control inputClass"
                    placeholder="Waga jednostkowa"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.unit_weight"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.unit_weight[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="productObj.horizontal"
                        name="horizontal"
                        type="checkbox"
                      />
                      <span>Orientacja pozioma</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="productObj.is_published"
                        name="is_published"
                        type="checkbox"
                      />
                      <span>Opublikowany</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="productObj.is_popular"
                        name="is_popular"
                        type="checkbox"
                      />
                      <span>Wyświetlaj w najpopularniejszych produktach</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="productObj.frozen_price"
                        name="frozen_price"
                        type="checkbox"
                      />
                      <span>Zamrożona cena</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="productObj.imposition"
                        name="imposition"
                        type="checkbox"
                      />
                      <span>Do impozycji</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="productObj.exclusive_sheet"
                        name="exclusive_sheet"
                        type="checkbox"
                      />
                      <span>Wyłączność na arkuszu</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Obrazek</label>
                <div class="col-sm-10">
                  <!-- Same layout as cp-input-file of the old panel: a
                       preview with "Wybierz plik" / "Zmień" and "Usuń". -->
                  <div class="product-image-input">
                    <div
                      class="thumbnail product-image-preview"
                      @click="openImagePicker"
                    >
                      <img v-if="imagePreview" :src="imagePreview" alt="" />
                    </div>
                    <div>
                      <span class="btn btn-default" @click="openImagePicker">
                        {{ imagePreview ? "Zmień" : "Wybierz plik" }}
                      </span>
                      <a
                        v-if="imagePreview"
                        href="#"
                        class="btn btn-default"
                        @click.prevent="removePhoto"
                      >
                        Usuń
                      </a>
                      <input
                        ref="imageInput"
                        type="file"
                        accept="image/*"
                        style="display: none"
                        @change="changePhoto"
                      />
                    </div>
                  </div>
                  <div v-if="errorsAdminData?.data?.image" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.image[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Data od</label>
                <div class="col-sm-10">
                  <VueDatePicker :format="format" v-model="date_from" />
                  <div
                    v-if="errorsAdminData?.data?.date_from"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.date_from[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Data do</label>
                <div class="col-sm-10">
                  <VueDatePicker :format="format" v-model="date_to" />
                  <div v-if="errorsAdminData?.data?.date_to" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.date_to[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="productObj.is_available_on_allegro"
                        type="checkbox"
                      />
                      <span>
                        Dostępny dla ofert Allegro (w kreatorze ofert)
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-4 col-sm-offset-2">
                  <router-link class="btn btn-white" to="/products">
                    Anuluj
                  </router-link>
                  <button
                    v-if="canAddProduct"
                    @click="create"
                    class="btn btn-primary"
                  >
                    Dodaj
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="mGroups" class="modal-dialog">
    <div class="modal-content">
      <div class="inmodal">
        <div class="modal-header">
          <h4 class="modal-title">Dodaj grupy opcji</h4>
        </div>
        <div class="modal-body">
          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <div class="col-sm-10">
                  <Multiselect
                    v-model="groupsToAdd"
                    mode="tags"
                    placeholder="Grupy opcji"
                    track-by="name"
                    label="name"
                    :close-on-select="false"
                    :searchable="true"
                    :options="availableGroups"
                    :hideSelected="true"
                  >
                  </Multiselect>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="mGroups = false" class="btn btn-white">Anuluj</button>
          <button @click="addGroup()" class="btn btn-primary">Dodaj</button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="mGroups" @click="mGroups = false" class="modal-backdrop"></div>
  <div v-if="mOptions" class="modal-dialog">
    <div class="modal-content">
      <div class="inmodal">
        <div class="modal-header">
          <h4 class="modal-title">Dodaj opcje</h4>
        </div>
        <div class="modal-body">
          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <div class="col-sm-10">
                  <Multiselect
                    v-model="optionsToAdd"
                    mode="tags"
                    placeholder="Opcje"
                    track-by="name"
                    label="name"
                    :close-on-select="false"
                    :searchable="true"
                    :options="availableGroupOptions"
                    :hideSelected="true"
                  >
                  </Multiselect>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="mOptions = false" class="btn btn-white">
            Anuluj
          </button>
          <button @click="addOption()" class="btn btn-primary">Dodaj</button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="mOptions" @click="mOptions = false" class="modal-backdrop"></div>
  <div v-if="mQuantityPrices" class="modal-dialog">
    <div class="modal-content">
      <div class="inmodal">
        <div class="modal-header">
          <h4 class="modal-title">Ceny opcji w nakładach</h4>
        </div>
        <div class="modal-body">
          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <div class="col-sm-12">
                  <table class="table table-bordered" width="100%">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Opcja</th>
                        <th>Cena</th>
                        <th>Akcja</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="row in quantityPriceRows" :key="row.pk">
                        <td>{{ row.pk }}</td>
                        <td>{{ row.option }}</td>
                        <td class="text-center">
                          <input
                            v-if="editingPriceKey === row.pk"
                            v-model="priceDraft"
                            type="number"
                            min="0"
                            class="form-control inputClass"
                            placeholder="Cena"
                          />
                          <span v-else>{{ row.price }}</span>
                        </td>
                        <td class="float-e-margins text-center">
                          <div v-if="editingPriceKey === row.pk">
                            <button
                              class="btn btn-success"
                              type="button"
                              title="Zapisz"
                              @click="saveQuantityOptionPrice(row)"
                            >
                              <font-awesome-icon
                                icon="check"
                                class="table-helper-item"
                              />
                            </button>
                            <button
                              class="btn btn-danger btn-xs"
                              type="button"
                              title="Anuluj"
                              @click="editingPriceKey = null"
                            >
                              <font-awesome-icon
                                icon="times"
                                class="table-helper-item"
                              />
                            </button>
                          </div>
                          <button
                            v-else-if="canChangeOptionPrice"
                            class="btn btn-warning"
                            title="Edytuj"
                            type="button"
                            @click="startEditPrice(row.pk, row.price)"
                          >
                            <font-awesome-icon
                              icon="pencil"
                              class="table-helper-item"
                            />
                          </button>
                        </td>
                      </tr>
                      <tr v-if="!quantityPriceRows.length">
                        <td colspan="4" class="text-center">
                          Produkt nie ma przypisanych opcji.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="mQuantityPrices = false" class="btn btn-primary">
            Zamknij
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="mQuantityPrices"
    @click="mQuantityPrices = false"
    class="modal-backdrop"
  />
  <div v-if="mGroupPrices" class="modal-dialog">
    <div class="modal-content">
      <div class="inmodal">
        <div class="modal-header">
          <h4 class="modal-title">Ceny w zależności od nakładu</h4>
        </div>
        <div class="modal-body">
          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <div class="col-sm-12">
                  <table class="table table-bordered" width="100%">
                    <thead>
                      <tr>
                        <th>Nakład</th>
                        <th>Cena</th>
                        <th>Akcja</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="row in optionPriceRows" :key="row.index">
                        <td>{{ row.quantity }}</td>
                        <td class="text-center">
                          <input
                            v-if="editingPriceKey === row.index"
                            v-model="priceDraft"
                            type="number"
                            min="0"
                            class="form-control inputClass"
                            placeholder="Cena"
                          />
                          <span v-else>{{ row.price }}</span>
                        </td>
                        <td class="float-e-margins text-center">
                          <div v-if="editingPriceKey === row.index">
                            <button
                              class="btn btn-success"
                              type="button"
                              title="Zapisz"
                              @click="saveOptionPriceByQuantity(row)"
                            >
                              <font-awesome-icon
                                icon="check"
                                class="table-helper-item"
                              />
                            </button>
                            <button
                              class="btn btn-danger btn-xs"
                              type="button"
                              title="Anuluj"
                              @click="editingPriceKey = null"
                            >
                              <font-awesome-icon
                                icon="times"
                                class="table-helper-item"
                              />
                            </button>
                          </div>
                          <button
                            v-else-if="canChangeOptionPrice"
                            class="btn btn-warning"
                            title="Edytuj"
                            type="button"
                            @click="startEditPrice(row.index, row.price)"
                          >
                            <font-awesome-icon
                              icon="pencil"
                              class="table-helper-item"
                            />
                          </button>
                        </td>
                      </tr>
                      <tr v-if="!optionPriceRows.length">
                        <td colspan="3" class="text-center">
                          Produkt nie ma nakładów.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="mGroupPrices = false" class="btn btn-primary">
            Zamknij
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="mGroupPrices"
    @click="mGroupPrices = false"
    class="modal-backdrop"
  />
</template>

<script>
import { computed, nextTick, reactive, ref, watch, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import { usePagedSelect } from "../../composables/usePagedSelect";
import { hasPermission } from "../../permissions";
import {
  productOptionGroupPermissionsConst,
  productOptionPermissionsConst,
  productoptionpricePermissionsConst,
  productPermissionsConst,
  productQuantityPermissionsConst,
} from "../../constants/productConstants";
import router from "../../router/router";
import { useRoute } from "vue-router";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import { ListBoxComponent as EjsListbox } from "@syncfusion/ej2-vue-dropdowns";
import { TooltipComponent as EjsTooltip } from "@syncfusion/ej2-vue-popups";
import { Query } from "@syncfusion/ej2-data";
import "/node_modules/@syncfusion/ej2-base/styles/material.css";
import "/node_modules/@syncfusion/ej2-inputs/styles/material.css";
import "/node_modules/@syncfusion/ej2-dropdowns/styles/material.css";

export default {
  name: "ProductsCreate",
  mixins: [],
  components: {
    Multiselect,
    EjsListbox,
    EjsTooltip,
  },
  props: {},

  setup() {
    // Defaults of the old product create view.
    const productObj = ref({
      categories: [],
      appliances: [],
      parameters: [],
      group_options: [],
      options: [],
      available_in_countries: [],
      quantities: [],
      deadline: 0,
      bleed: 3.0,
      text_margin: 0.0,
      unit_weight: 0.0,
      horizontal: false,
      is_published: true,
      is_popular: false,
      frozen_price: false,
      imposition: false,
      exclusive_sheet: false,
      from_warehouse: false,
      is_available_on_allegro: false,
    });
    const date_from = ref();
    const date_to = ref();

    const countries = ref(["PL", "DE"]);
    const quantities = ref({});
    const options = ref([]);
    const formats = ref([]);
    const packages = ref([]);
    const categories = ref([]);
    const pages = ref([]);
    const appliances = ref([]);
    const parameters = ref([]);
    const pOptions = ref([]);
    const selectedOptions = ref([]);
    const filteredParams = ref([]);
    const selParameters = ref([]);
    const selFilteredParameters = ref([]);
    const paramOptions = ref({});
    const errorsAdminData = ref();
    const quantityIndex = ref();
    const mGroups = ref(false);
    const mGroupPrices = ref(false);
    const groupPricesPk = ref();
    const mQuantityPrices = ref(false);
    const mOptions = ref(false);
    const isEdit = ref(false);
    const showErrors = ref(false);
    const showModalErrors = ref(false);

    const store = useStore();
    const route = useRoute();
    const canAddProduct = computed(() =>
      hasPermission(productPermissionsConst.add)
    );
    // Quantities, option groups, options and option prices are separate models
    // in the old panel, each section gated by its own permissions.
    const canViewQuantity = computed(() =>
      hasPermission(productQuantityPermissionsConst.view)
    );
    const canAddQuantity = computed(() =>
      hasPermission(productQuantityPermissionsConst.add)
    );
    const canDeleteQuantity = computed(() =>
      hasPermission(productQuantityPermissionsConst.delete)
    );
    const canViewOptionGroup = computed(() =>
      hasPermission(productOptionGroupPermissionsConst.view)
    );
    const canAddOptionGroup = computed(() =>
      hasPermission(productOptionGroupPermissionsConst.add)
    );
    const canDeleteOptionGroup = computed(() =>
      hasPermission(productOptionGroupPermissionsConst.delete)
    );
    const canAddOption = computed(() =>
      hasPermission(productOptionPermissionsConst.add)
    );
    const canDeleteOption = computed(() =>
      hasPermission(productOptionPermissionsConst.delete)
    );
    const canViewOptionPrice = computed(() =>
      hasPermission(productoptionpricePermissionsConst.view)
    );
    const canChangeOptionPrice = computed(() =>
      hasPermission(productoptionpricePermissionsConst.update)
    );
    const createProductsData = computed(
      () => store.getters.getCreateProductsData
    );
    const productOptionsData = computed(
      () => store.getters.getProductOptionsData
    );
    const pagesData = computed(() => store.getters.getProductPagesData);
    const parametersData = computed(() => store.getters.getAdminParametersData);
    const paOptionsGroupData = computed(
      () => store.getters.getpaOptionsGroupData
    );
    const adminProductOptionsData = computed(
      () => store.getters.getAdminProductOptionsData
    );
    const fields = { text: "Name", value: "Code" };
    const toolbarSettings = {
      items: ["moveTo", "moveFrom", "moveAllTo", "moveAllFrom"],
    };
    let headers = [
      { text: "Nakład", value: "quantity", sortable: true },
      {
        text: "Nakład widoczny",
        value: "display_quantity",
        sortable: true,
      },
      {
        text: "Cena",
        value: "price",
        sortable: true,
      },
      {
        text: "Dni realizacji",
        value: "realization_days",
        sortable: true,
      },
      { text: "Akcje", value: "actions" },
    ];
    // Main image picker like cp-input-file of the old panel - a picked file
    // is previewed locally, a saved image is shown from its URL.
    const imageInput = ref(null);
    const localImageUrl = ref("");
    const imagePreview = computed(() => {
      if (localImageUrl.value) {
        return localImageUrl.value;
      }
      return typeof productObj.value.image === "string"
        ? productObj.value.image
        : "";
    });

    const setLocalImageUrl = (file) => {
      if (localImageUrl.value) {
        window.URL.revokeObjectURL(localImageUrl.value);
      }
      localImageUrl.value = file ? window.URL.createObjectURL(file) : "";
    };

    const openImagePicker = () => {
      imageInput.value?.click();
    };

    const changePhoto = (event) => {
      const file = event.target.files?.[0];
      event.target.value = "";
      if (!file) {
        return;
      }
      productObj.value.image = file;
      setLocalImageUrl(file);
    };

    // Without a file the new product is created with no image.
    const removePhoto = () => {
      productObj.value.image = undefined;
      setLocalImageUrl(null);
    };

    onBeforeUnmount(() => setLocalImageUrl(null));

    const isEmptyValue = (value) =>
      value === "" || value === null || value === undefined;

    const normalizeOptionId = (id) => {
      const numericId = Number(id);
      return Number.isNaN(numericId) ? id : numericId;
    };

    // The deadline is a time field accepting HH:MM:SS only - a time input may
    // give HH:MM, and an empty one means no deadline, like the old timepicker.
    const normalizeDeadlineTime = (value) => {
      if (!value) {
        return null;
      }
      return /^\d{2}:\d{2}$/.test(value) ? value + ":00" : value;
    };

    const create = () => {
      if (!canAddProduct.value) {
        return;
      }
      showErrors.value = true;
      const selParams =
        document.getElementById("listbox")?.ej2_instances?.[0]?.getDataList() ||
        [];
      const selOptions =
        document
          .getElementById("listbox1")
          ?.ej2_instances?.[0]?.getDataList() || [];

      // The request data is built from scratch on every attempt, so a retry
      // after a validation error sends no duplicated parameters or options.
      const payload = {
        ...productObj.value,
        parameters: selParams.map((element) => ({
          parameter: element.Code,
          parameter_options: (paramOptions.value[element.Code] || []).map(
            (id) => normalizeOptionId(id)
          ),
        })),
        options: selOptions.map((element) => element.Code),
        quantities: productObj.value.quantities
          .filter((quantity) => !quantity.isNew)
          .map((quantity) => {
            const row = {
              quantity: quantity.quantity,
              display_quantity: quantity.display_quantity,
              price: quantity.price,
            };
            // Like the old panel, prices are sent only when some were entered.
            if (
              quantity.prices &&
              !Array.isArray(quantity.prices) &&
              Object.keys(quantity.prices).length
            ) {
              row.prices = quantity.prices;
            }
            if (!isEmptyValue(quantity.realization_days)) {
              row.realization_days = quantity.realization_days;
            }
            return row;
          }),
      };

      // The backend accepts dates as dd.mm.yyyy only.
      const dateFrom = format(date_from.value);
      const dateTo = format(date_to.value);
      if (dateFrom) {
        payload.date_from = dateFrom;
      }
      if (dateTo) {
        payload.date_to = dateTo;
      }
      payload.deadline_time = normalizeDeadlineTime(payload.deadline_time);
      if (!(payload.image instanceof File)) {
        delete payload.image;
      }

      store.dispatch("createProducts", payload);
    };

    const addQuantities = () => {
      if (!canAddQuantity.value) {
        return;
      }
      let index = 0;
      if (productObj.value.quantities.length > 0) {
        productObj.value.quantities[
          productObj.value.quantities.length - 1
        ].isNew = false;

        index =
          productObj.value.quantities[productObj.value.quantities.length - 1]
            .id + 1;
        if (!index && index !== 0) {
          index = 0;
        }
      }

      productObj.value.quantities.push({
        quantity: "",
        display_quantity: "",
        price: "",
        realization_days: "",
        id: index,
        isNew: true,
      });
    };

    const saveQuantity = () => {
      showModalErrors.value = true;
      const draft = quantities.value;
      if (
        isEmptyValue(draft.quantity) ||
        isEmptyValue(draft.display_quantity) ||
        isEmptyValue(draft.price)
      ) {
        return;
      }
      const last = productObj.value.quantities.length - 1;
      if (last < 0) {
        return;
      }
      productObj.value.quantities[last] = {
        ...draft,
        id: productObj.value.quantities[last].id,
        prices: {},
      };
      quantities.value = {};
      showModalErrors.value = false;
    };

    // Quantities are sent together with the new product, so a local removal
    // is enough.
    const removeQuantity = (item) => {
      if (!canDeleteQuantity.value) {
        return;
      }
      productObj.value.quantities = productObj.value.quantities.filter(
        (quantity) => quantity.id !== item.id
      );
    };

    // Drops the new, not yet confirmed quantity row.
    const cancelQuantity = () => {
      productObj.value.quantities = productObj.value.quantities.filter(
        (quantity) => !quantity.isNew
      );
      quantities.value = {};
      showModalErrors.value = false;
    };

    // Option groups of the product - mirrors the group options table of the old
    // product views: groups keep the backend shape
    // {group_option, group_option_name, options: [{option, option_name,
    // position}]} and are saved together with the product.
    const expandedGroupIds = ref([]);
    const groupsToAdd = ref([]);
    const optionsToAdd = ref([]);
    const optionsModalGroup = ref(null);
    const draggedGroupIndex = ref(null);
    const draggedOption = ref(null);

    // Groups with their options, the list productGroupOptions gives the old
    // panel.
    const groupOptionsList = computed(() =>
      paOptionsGroupData.value?.status === 200 &&
      Array.isArray(paOptionsGroupData.value.data)
        ? paOptionsGroupData.value.data
        : []
    );
    const optionsList = computed(() =>
      adminProductOptionsData.value?.status === 200 &&
      Array.isArray(adminProductOptionsData.value.data)
        ? adminProductOptionsData.value.data
        : []
    );

    const availableGroups = computed(() => {
      const assigned = (productObj.value.group_options || []).map(
        (group) => group.group_option
      );
      return groupOptionsList.value
        .filter((group) => !assigned.includes(group.pk))
        .map((group) => ({
          name: `[${group.pk}] ${group.name}`,
          value: group.pk,
        }));
    });

    const availableGroupOptions = computed(() => {
      const row = optionsModalGroup.value;
      if (!row) {
        return [];
      }
      const group = groupOptionsList.value.find(
        (item) => item.pk === row.group_option
      );
      const assigned = (row.options || []).map((option) => option.option);
      return (group?.product_options || [])
        .filter((option) => !assigned.includes(option.pk))
        .map((option) => ({
          name: `[${option.pk}] ${option.label}`,
          value: option.pk,
        }));
    });

    // The page count, cover page count and deadline selects offer the groups
    // assigned to the product plus the groups of its directly assigned options,
    // like getGroupOptionsForPageNum in the old panel.
    const groupOptionsForPageNum = computed(() => {
      const allowed = new Set(
        (productObj.value.group_options || []).map(
          (group) => group.group_option
        )
      );
      (productObj.value.options || []).forEach((optionPk) => {
        const option = optionsList.value.find((item) => item.pk === optionPk);
        if (option) {
          allowed.add(option.options_group);
        }
      });
      return groupOptionsList.value
        .filter((group) => allowed.has(group.pk))
        .sort((a, b) => a.pk - b.pk)
        .map((group) => ({
          name: `[${group.pk}] ${group.name}`,
          value: group.pk,
        }));
    });

    const isGroupExpanded = (group) =>
      expandedGroupIds.value.includes(group.group_option);

    const toggleGroup = (group) => {
      expandedGroupIds.value = isGroupExpanded(group)
        ? expandedGroupIds.value.filter((pk) => pk !== group.group_option)
        : [...expandedGroupIds.value, group.group_option];
    };

    const addGroupOptions = () => {
      if (!canAddOptionGroup.value) {
        return;
      }
      groupsToAdd.value = [];
      mGroups.value = true;
    };

    const addGroup = () => {
      if (!canAddOptionGroup.value) {
        return;
      }
      if (!Array.isArray(productObj.value.group_options)) {
        productObj.value.group_options = [];
      }
      groupsToAdd.value.forEach((groupPk) => {
        const group = groupOptionsList.value.find(
          (item) => item.pk === groupPk
        );
        if (group) {
          productObj.value.group_options.push({
            group_option: group.pk,
            group_option_name: group.name,
            options: [],
          });
        }
      });
      groupsToAdd.value = [];
      mGroups.value = false;
    };

    const removeGroup = (group) => {
      if (!canDeleteOptionGroup.value) {
        return;
      }
      productObj.value.group_options = productObj.value.group_options.filter(
        (item) => item.group_option !== group.group_option
      );
      expandedGroupIds.value = expandedGroupIds.value.filter(
        (pk) => pk !== group.group_option
      );
    };

    const openOptionsModal = (group) => {
      if (!canAddOption.value) {
        return;
      }
      optionsModalGroup.value = group;
      optionsToAdd.value = [];
      mOptions.value = true;
    };

    const addOption = () => {
      const row = optionsModalGroup.value;
      if (!canAddOption.value || !row) {
        return;
      }
      const group = groupOptionsList.value.find(
        (item) => item.pk === row.group_option
      );
      if (!Array.isArray(row.options)) {
        row.options = [];
      }
      optionsToAdd.value.forEach((optionPk) => {
        const option = (group?.product_options || []).find(
          (item) => item.pk === optionPk
        );
        if (option) {
          row.options.push({
            option: option.pk,
            option_name: option.label,
            position: row.options.length,
          });
        }
      });
      optionsToAdd.value = [];
      optionsModalGroup.value = null;
      mOptions.value = false;
    };

    // Option groups are sent as a whole with the product, so removing the
    // option locally is enough - saving the product drops it.
    const removeOption = (group, option) => {
      if (!canDeleteOption.value) {
        return;
      }
      group.options = (group.options || []).filter(
        (item) => item.option !== option.option
      );
    };

    // Reordering numbers the positions from 1, like the reorder handlers of
    // the old panel; the positions are saved with the product.
    const onGroupDragStart = (index) => {
      draggedGroupIndex.value = index;
    };

    const onGroupDrop = (index) => {
      const from = draggedGroupIndex.value;
      draggedGroupIndex.value = null;
      if (from === null || from === index) {
        return;
      }
      const groups = [...productObj.value.group_options];
      const [moved] = groups.splice(from, 1);
      groups.splice(index, 0, moved);
      groups.forEach((group, position) => {
        group.position = position + 1;
      });
      productObj.value.group_options = groups;
    };

    const onOptionDragStart = (group, index) => {
      draggedOption.value = { group: group.group_option, index };
    };

    const onOptionDrop = (group, index) => {
      const dragged = draggedOption.value;
      draggedOption.value = null;
      if (
        !dragged ||
        dragged.group !== group.group_option ||
        dragged.index === index
      ) {
        return;
      }
      const groupOptions = [...group.options];
      const [moved] = groupOptions.splice(dragged.index, 1);
      groupOptions.splice(index, 0, moved);
      groupOptions.forEach((option, position) => {
        option.position = position + 1;
      });
      group.options = groupOptions;
    };

    // Keeps productObj.options in step with the "selected" options listbox, so
    // the page count groups follow it like onProductOptionsChange does.
    const syncSelectedOptions = () => {
      nextTick(() => {
        const listbox = document.getElementById("listbox1")?.ej2_instances?.[0];
        if (listbox) {
          productObj.value.options = listbox
            .getDataList()
            .map((element) => element.Code);
        }
      });
    };

    const tooltipRef = ref(null);
    const lastHoveredElement = ref();

    const generateCheckboxesHtml = (checkboxes, pk) => {
      let html = "";
      const selectedOptions = (paramOptions.value[pk] || []).map((id) =>
        String(id)
      );
      for (const cb of checkboxes) {
        const isChecked = selectedOptions.includes(String(cb.pk));
        html += `
          <label style="display:block; margin-bottom:4px;">
            <input type="checkbox" data-id="${cb.pk}" data-pk="${pk}"
            ${isChecked ? "checked" : ""} />
            ${cb.name}
          </label>`;
      }

      return html;
    };

    const onItemChange = (event) => {
      const targetElement = event.event.target.closest(".e-list-item");
      if (!targetElement) return;

      if (lastHoveredElement.value === targetElement) {
        tooltipRef.value.ej2Instances.close();
        lastHoveredElement.value = null;
      } else {
        lastHoveredElement.value = targetElement;
        const selectedItem = event.value[0];
        const itemData = parametersData.value.data.find(
          (i) => i.pk === selectedItem
        );
        nextTick(() => {
          const selectedEl = document.querySelector(
            ".listbox2 .e-list-item.e-selected"
          );

          tooltipRef.value.ej2Instances.content = `<div>
            <h4>${itemData.name}</h4>
            <p>${generateCheckboxesHtml(itemData.options, itemData.pk)}</p>
          </div>`;
          tooltipRef.value.ej2Instances.open(selectedEl);
        });
      }
    };

    const onCheckboxChange = (e) => {
      const pk = e.target.dataset.pk;
      const id = normalizeOptionId(e.target.dataset.id);

      if (!paramOptions.value[pk]) {
        paramOptions.value[pk] = [];
      }

      const index = paramOptions.value[pk].indexOf(id);
      if (index === -1) {
        paramOptions.value[pk].push(id);
      } else {
        paramOptions.value[pk].splice(index, 1);
      }
    };

    const onTooltipAfterOpen = () => {
      const tooltipEl = document.querySelector(".e-tooltip-wrap");
      if (tooltipEl) {
        tooltipEl
          .querySelectorAll("input[type='checkbox']")
          .forEach((input) => {
            input.addEventListener("change", onCheckboxChange);
          });
      }
    };

    const onFiltering = (e) => {
      const searchText = (e.text || "").toLowerCase();
      if (searchText === "") {
        filteredParams.value = [...parameters.value];
      } else {
        filteredParams.value = parameters.value.filter((item) =>
          (item.Name || "").toLowerCase().includes(searchText)
        );
      }
      e.updateData(filteredParams.value, new Query(), fields);
    };

    const onFilteringSel = (e) => {
      const searchText = (e.text || "").toLowerCase();
      if (searchText === "") {
        selFilteredParameters.value = [...selParameters.value];
      } else {
        selFilteredParameters.value = selParameters.value.filter((item) =>
          (item.Name || "").toLowerCase().includes(searchText)
        );
      }
      e.updateData(selFilteredParameters.value, new Query(), fields);
    };

    const quantityPrices = (item) => {
      let index = productObj.value.quantities.findIndex((x) => x.id == item.id);
      mQuantityPrices.value = true;
      editingPriceKey.value = null;
      quantityIndex.value = index;
      if (
        !productObj.value.quantities[index].prices ||
        Array.isArray(productObj.value.quantities[index].prices)
      ) {
        productObj.value.quantities[index].prices = {};
      }
    };

    // Option prices of a new product live in quantity.prices keyed by option,
    // like the ProductOptionPrices...Create modals - the backend creates them
    // together with the quantities.
    const quantityPriceRows = computed(() => {
      const quantity = productObj.value.quantities[quantityIndex.value];
      if (!quantity) {
        return [];
      }
      return (productObj.value.group_options || [])
        .flatMap((group) => group.options || [])
        .map((item) => ({
          pk: item.option,
          option: item.option_name,
          price: quantity.prices?.[item.option] ?? 0,
        }));
    });

    const optionPriceRows = computed(() => {
      if (!groupPricesPk.value) {
        return [];
      }
      return productObj.value.quantities.map((quantity, index) => ({
        index,
        quantity: quantity.quantity,
        price: quantity.prices?.[groupPricesPk.value] ?? 0,
      }));
    });

    const setOptionPrice = (index, optionPk, price) => {
      const quantity = productObj.value.quantities[index];
      if (!canChangeOptionPrice.value || !quantity) {
        return;
      }
      const prices =
        quantity.prices && !Array.isArray(quantity.prices)
          ? quantity.prices
          : {};
      quantity.prices = { ...prices, [optionPk]: price };
    };

    // One price is edited at a time and kept in the quantity on save, like the
    // editable rows of the old create modals.
    const editingPriceKey = ref(null);
    const priceDraft = ref(0);

    const startEditPrice = (key, price) => {
      if (!canChangeOptionPrice.value) {
        return;
      }
      editingPriceKey.value = key;
      priceDraft.value = price;
    };

    const saveQuantityOptionPrice = (row) => {
      setOptionPrice(quantityIndex.value, row.pk, priceDraft.value);
      editingPriceKey.value = null;
    };

    const saveOptionPriceByQuantity = (row) => {
      setOptionPrice(row.index, groupPricesPk.value, priceDraft.value);
      editingPriceKey.value = null;
    };

    const groupPrices = (item) => {
      if (!canViewOptionPrice.value) {
        store.dispatch("showToaster", {
          type: "error",
          content: productoptionpricePermissionsConst.view.errorMsg,
        });
        return;
      }
      groupPricesPk.value = item.option;
      editingPriceKey.value = null;
      mGroupPrices.value = true;
    };

    const format = (date) => {
      if (!(date instanceof Date)) {
        return undefined;
      }
      const day = ("0" + date.getDate()).slice(-2);
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      return `${day}.${month}.${date.getFullYear()}`;
    };

    // Material files are searched on the server by name and the next page is
    // loaded while a dropdown is scrolled, like the material ui-selects of the
    // old panel. The five selects share the first request.
    const materialKeys = [
      "materials_pl",
      "materials_en",
      "materials_de",
      "materials_cpde",
      "materials_cpen",
    ];
    const toMaterialOption = (element) => ({
      name: "[" + element.pk + "] " + element.name,
      value: element.pk,
    });
    const materialSelects = reactive(
      Object.fromEntries(
        materialKeys.map((key) => [
          key,
          usePagedSelect({
            fetchPage: ({ page, query }) =>
              store.dispatch("searchProductMaterials", {
                productPk: route.params?.pk,
                name: query,
                page,
              }),
            toOption: toMaterialOption,
            getSelected: () => productObj.value[key],
          }),
        ])
      )
    );
    store
      .dispatch("searchProductMaterials", { productPk: route.params?.pk })
      .then((response) => {
        materialKeys.forEach((key) =>
          materialSelects[key].setFirstPage(response)
        );
      })
      .catch(() => {});

    const toOptions = (response, labelKey) =>
      (Array.isArray(response?.data) ? response.data : []).map((element) => ({
        name: "[" + element.pk + "] " + element[labelKey],
        value: element.pk,
      }));

    store
      .dispatch("fetchProductPackageOptions")
      .then((response) => {
        packages.value = toOptions(response, "name");
      })
      .catch(() => {});
    store
      .dispatch("fetchProductCategoryParents")
      .then((response) => {
        categories.value = toOptions(response, "title");
      })
      .catch(() => {});
    store
      .dispatch("fetchProductAppliances")
      .then((response) => {
        appliances.value = toOptions(response, "name");
      })
      .catch(() => {});
    store
      .dispatch("fetchProductFormatOptions")
      .then((response) => {
        formats.value = (
          Array.isArray(response?.data) ? response.data : []
        ).map((element) => ({
          name:
            "[" + element.pk + "] " + element.size_x + " x " + element.size_y,
          value: element.pk,
        }));
      })
      .catch(() => {});
    store.dispatch("getProductOptions");
    store.dispatch("getProductPages");
    store.dispatch("getAdminParameters");
    store.dispatch("getAdminProductOptions");
    store.dispatch("getpOptionsAdminGroup");

    watch(
      () => createProductsData.value,
      function (newValue) {
        if (newValue.status === 201) {
          router.push({ name: "ProductsList", path: "/products" }).then(() => {
            store.dispatch("showToaster", {
              type: "success",
              content: "Nowy produkt został dodany",
            });
          });
        } else {
          var msg = [];
          for (const [key, value] of Object.entries(newValue.data)) {
            msg.push(key + ": " + value);
          }
          store.dispatch("showToaster", {
            type: "error",
            content: msg[0],
          });
          errorsAdminData.value = newValue;
        }
      }
    );

    watch(
      () => productOptionsData.value,
      function (newValue) {
        if (newValue.status === 200) {
          newValue.data?.forEach((element) => {
            options.value.push({
              name: element[1],
              value: element[0],
            });
          });
        }
      }
    );

    watch(
      () => pagesData.value,
      function (newValue) {
        if (newValue.status === 200) {
          pages.value = (newValue.data || []).map((element) => ({
            name: "[" + element.pk + "] " + element.title_seo,
            value: element.pk,
          }));
        }
      }
    );
    watch(
      () => parametersData.value,
      function (newValue) {
        if (newValue.status === 200) {
          parameters.value = newValue.data.map((element) => ({
            Name: "[" + element.pk + "] " + element.name,
            Code: element.pk,
          }));
          filteredParams.value = [...parameters.value];
          selParameters.value = [];
          selFilteredParameters.value = [];
        }
      }
    );

    watch(
      () => adminProductOptionsData.value,
      function (newValue) {
        if (newValue.status === 200) {
          newValue.data?.forEach((element) => {
            pOptions.value.push({
              Name:
                "[" +
                element.options_group +
                "] " +
                element.options_group_name +
                "[" +
                element.pk +
                "]" +
                element.label,
              Code: element.pk,
            });
          });
        }
      }
    );

    return {
      imageInput,
      imagePreview,
      openImagePicker,
      editingPriceKey,
      priceDraft,
      startEditPrice,
      saveQuantityOptionPrice,
      saveOptionPriceByQuantity,
      removePhoto,
      date_from,
      date_to,
      filteredParams,
      selFilteredParameters,
      setOptionPrice,
      quantityPriceRows,
      optionPriceRows,
      onItemChange,
      tooltipRef,
      onTooltipAfterOpen,
      onFiltering,
      onFilteringSel,
      groupsToAdd,
      optionsToAdd,
      availableGroups,
      availableGroupOptions,
      groupOptionsForPageNum,
      isGroupExpanded,
      toggleGroup,
      onGroupDragStart,
      onGroupDrop,
      onOptionDragStart,
      onOptionDrop,
      syncSelectedOptions,
      changePhoto,
      canAddProduct,
      canViewQuantity,
      canAddQuantity,
      canDeleteQuantity,
      canViewOptionGroup,
      canAddOptionGroup,
      canDeleteOptionGroup,
      canAddOption,
      canDeleteOption,
      canViewOptionPrice,
      canChangeOptionPrice,
      productObj,
      errorsAdminData,
      showErrors,
      create,
      mGroups,
      mOptions,
      addGroup,
      headers,
      showModalErrors,
      isEdit,
      addQuantities,
      saveQuantity,
      removeQuantity,
      cancelQuantity,
      removeOption,
      materialSelects,
      options,
      formats,
      format,
      packages,
      categories,
      pages,
      appliances,
      countries,
      parameters,
      fields,
      toolbarSettings,
      pOptions,
      selectedOptions,
      quantities,
      addGroupOptions,
      removeGroup,
      addOption,
      openOptionsModal,
      quantityPrices,
      mQuantityPrices,
      quantityIndex,
      mGroupPrices,
      groupPrices,
      groupPricesPk,
    };
  },
  computed: {},
};
</script>
<style>
@import "../../../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-inputs/styles/material.css";
@import "../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css";
</style>

<style scoped>
.product-image-preview {
  width: 200px;
  height: 150px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.product-image-preview img {
  max-width: 100%;
  max-height: 100%;
}
.drag-column {
  width: 30px;
  cursor: move;
  color: #999;
}
.product-gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.product-gallery-item {
  position: relative;
}
.product-gallery-item img {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border: 1px solid #e7eaec;
}
.product-gallery-remove {
  position: absolute;
  top: 4px;
  right: 4px;
}
</style>
